import ListTemplate from "components/ListTemplate";
import { CompanySidePanel } from "components/SidePanel/Company/CompanySidePanel";
import TagList from "components/Tag/TagList";
import React from "react";
import { useLoaderData } from "react-router";
import Filters from "./Filters";
import { mapFilterValuesToInstruction, mapResponseToFilterValues } from "./helpers";
import { getCityStateCountry } from "shared/utils/addressUtils";

const VenueListApp = () => {
  const viewModel = useLoaderData<server.viewmodel.VenueListFrontModel>();

  return <ListTemplate
    title={site.currentEnvironment.functionGroups.venue.plural}
    filterSet="company_Venue_List"
    defaultFilters={viewModel.defaultFilters}
    initialInstruction={viewModel.initialInstruction}
    fetchFunction={window.CoreApi.Venue.Paginated}
    getId={item => item.venueId}
    layout={{
      type: "table",
      columns: [{
        key: "name",
        header: RESX.GeneralLabels.Name,
        render: item => <CompanySidePanel type="venue" companyId={item.venueId} trigger={<a>{item.name}</a>} />,
        size: "2fr"
      }, {
        key: "city",
        header: RESX.Address.City,
        render: item => getCityStateCountry(item.address),
        size: "2fr"
      }, {
        key: "category",
        header: RESX.Venue.Category,
        render: item => item.category !== "unknown" ? serverReference.venueCategories.find((val) => val.value === item.category).text : "",
        size: "1fr"
      }, {
        key: "tags",
        header: "",
        render: item => <TagList tags={item.tags} version="short" />,
        size: "fit-content(200px)"
      }, {
        key: "capacity",
        header: RESX.Venue.Capacity,
        render: item => item.capacity + " PAX",
        className: "s1_cell_financialamount"
      }]
    }}
    filters={<Filters initialTags={viewModel.tags} />}
    functions={{
      mapResponseToFilterValues,
      mapFilterValuesToInstruction
    }}
  />;
};

export default VenueListApp;
